module.exports = __webpack_public_path__ + "img/Agile-learning_sm.ea77204d.jpg";